import React, { useState } from "react";
import { useWizard } from "../../../../components/wizard/WizardContext";
import SingleBulkSearchPanel from "../../../../components/SingleBulkSearchPanel/SingleBulkSearchPanel";
import {
  getBulkSearchFormFields,
  searchStudents,
  singleSearchParams,
} from "./constants";
import { useGetCourseIdsForBUAndTerm } from "../../../../views/pages/manage/edpOps/stockManagement/customhooks";
import { useSearchStudentsHandler } from "../../customHooks";
import StudentTransfersListing from "./studentTransfersListing/StudentTransfersListing";
import { createTransferObjects } from "../verifyPayments/constant";
import { getBulkOnlyFilters } from "../utils";
import StudentTransferRequestCards from "../..";

const SearchStudent = () => {
  const { dropdowns, values, next, setSearchWizard, updateValues } =
    useWizard();
  const { searchHandler } = useSearchStudentsHandler();

  const [filterForm, setFilterForm] = useState(
    getBulkOnlyFilters(values?.searchStudentsFilters ?? {})
  );

  const [showTransferRequestsList , setShowTransferRequestsList] = useState(false);

  const [courseIdDropdown, courseIdDropdownLoading] =
    useGetCourseIdsForBUAndTerm({
      businessArea: filterForm?.businessArea,
      term: filterForm?.term,
    });

  const filterFormHandler = (key, val) => {
    setFilterForm((prev) => ({ ...prev, [key]: val }));
  };

  const studentSearchHandler = async (filters, offset = 0) => {
    searchHandler(filters, offset, true, 50, searchStudents);
  };

  const handleEditTransfer = (studentDetails) => {
    const { transferDetails, selectedStudent } =
      createTransferObjects(studentDetails, dropdowns?.data);
    updateValues("transferDetails", transferDetails);
    updateValues("selectedStudent", selectedStudent);
    next(1);
    setSearchWizard((prev) => ({ ...prev, isShow: false }));
  };

  const resetCourseId = () =>
    setFilterForm((prev) => ({ ...prev, courseIds: "" }));

  return (
    <div>
      {showTransferRequestsList
        ?
        <StudentTransfersListing
          dropdownData={dropdowns}
          handleEditTransfer={handleEditTransfer}
          setShowTransferRequestsList={setShowTransferRequestsList}
        />
        :
        <>
          <SingleBulkSearchPanel
            panelHeading="Search students to create transfer request"
            searchBtnTxt="Search Students"
            singleSearchParams={singleSearchParams}
            bulkSearchFormFields={getBulkSearchFormFields({
              ...dropdowns?.data,
              courseIdDropdown,
              courseIdDropdownLoading,
              resetCourseId,
            })}
            bulkSearchForm={filterForm}
            bulkSearchFormHandler={filterFormHandler}
            searchHandler={studentSearchHandler}
          />

          <StudentTransferRequestCards
            setShowTransferRequestsList={setShowTransferRequestsList}
          />
        </>
      }

    </div>
  );
};

export default SearchStudent;
